import { useFragment } from '@apollo/client/react';
import { Box, Menu } from '@pocketlaw/tetris';
import { TextAreaField } from 'app/domains/tasks/components/TextAreaField';
import { AddMetadataLabelFragmentFragmentDoc } from './AddMetadataLabelFragment.gql';
import { RemoveSelection } from './RemoveSelection';
import { SubmitSelection } from './SubmitSelection';
export function AddMetadataMultiLineTextSelection(props) {
    const { from } = props;
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataLabelFragmentFragmentDoc,
    });
    if (!complete) {
        return null;
    }
    return (<Menu.ItemNested target={data.label}>
      <Box flexDirection="column" px="md" mb="md">
        <TextAreaField name="value" label={data.label}/>
      </Box>
      <Menu.Footer sticky withoutPadding>
        <SubmitSelection />
        <RemoveSelection />
      </Menu.Footer>
    </Menu.ItemNested>);
}
